<script lang="ts">
    import type {Labeled} from 'src/typings';
    import Label from './Label.svelte';

    export let labeleds: Labeled[];
    export let linkifyUrls = false;
</script>

{#each labeleds as label, index}
    <Label labeled={label} linkifyUrls={linkifyUrls}/>
    {#if index !== (labeleds.length - 1)}
        <span> - </span>
    {/if}
{/each}